export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CHOOSE THE COURSE YOU ARE FOLLOWING"])},
        "logOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign out"])}
      },
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kies de module die u momenteel volgt"])},
        "logOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afmelden"])}
      }
    }
  })
}
